"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationOrderDelivery',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: 20,
        keywords: '',
        deliveryType: '',
        deliveryStatus: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      deliveryTypeText: {
        main_material: '主材',
        hvac: '暖通',
        soft_furnishing: '软装'
      },
      statusText: {
        pending: '待交付',
        delivered: '已交付',
        signed: '已签收'
      },
      statusTag: {
        pending: 'warning',
        delivered: '',
        signed: 'success'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationOrderDeliveryListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: 20,
        keywords: '',
        deliveryType: '',
        deliveryStatus: ''
      };
      this.getList();
    }
  }
};